const SvgFileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.3}
      d="M10.5 22h4c3.771 0 5.657 0 6.828-1.172S22.5 17.771 22.5 14v-.437c0-1.755 0-2.632-.346-3.409s-.998-1.364-2.302-2.537l-3.96-3.563c-1.127-1.015-1.69-1.523-2.383-1.788C12.817 2 12.055 2 10.53 2 6.74 2 4.844 2 3.673 3.172S2.5 6.229 2.5 10v4c0 3.771 0 5.657 1.172 6.828S6.729 22 10.5 22"
    />
    <path
      fill="#F79133"
      d="m15.893 4.054-.502.557zm3.959 3.563-.502.557zm2.302 2.537-.685.305zM3.672 20.828l.53-.53zm17.656 0-.53-.53zm-6.828.422h-4v1.5h4zM3.25 14v-4h-1.5v4zm18.5-.437V14h1.5v-.437zM15.391 4.61l3.959 3.563 1.003-1.115-3.958-3.563zm7.859 8.952c0-1.689.015-2.758-.41-3.714l-1.371.61c.266.598.281 1.283.281 3.104zm-3.9-5.389c1.353 1.218 1.853 1.688 2.119 2.285l1.37-.61c-.426-.957-1.23-1.66-2.486-2.79zM10.53 2.75c1.582 0 2.179.012 2.71.216l.538-1.4c-.852-.328-1.78-.316-3.248-.316zm5.865.746c-1.086-.977-1.765-1.604-2.617-1.93l-.537 1.4c.532.204.98.592 2.15 1.645zM10.5 21.25c-1.907 0-3.261-.002-4.29-.14-1.005-.135-1.585-.389-2.008-.812l-1.06 1.06c.748.75 1.697 1.081 2.869 1.239 1.15.155 2.625.153 4.489.153zM1.75 14c0 1.864-.002 3.338.153 4.489.158 1.172.49 2.121 1.238 2.87l1.06-1.06c-.422-.424-.676-1.004-.811-2.01-.138-1.027-.14-2.382-.14-4.289zm12.75 8.75c1.864 0 3.338.002 4.489-.153 1.172-.158 2.121-.49 2.87-1.238l-1.06-1.06c-.424.422-1.004.676-2.01.811-1.027.138-2.382.14-4.289.14zM21.75 14c0 1.907-.002 3.262-.14 4.29-.135 1.005-.389 1.585-.812 2.008l1.06 1.06c.75-.748 1.081-1.697 1.239-2.869.155-1.15.153-2.625.153-4.489zm-18.5-4c0-1.907.002-3.261.14-4.29.135-1.005.389-1.585.812-2.008l-1.06-1.06c-.75.748-1.081 1.697-1.239 2.869C1.748 6.661 1.75 8.136 1.75 10zm7.28-8.75c-1.875 0-3.356-.002-4.511.153-1.177.158-2.129.49-2.878 1.238l1.06 1.06c.424-.422 1.005-.676 2.017-.811 1.033-.138 2.395-.14 4.312-.14z"
    />
    <path
      stroke="#F79133"
      strokeWidth={1.5}
      d="M13.5 2.5V5c0 2.357 0 3.536.732 4.268S16.143 10 18.5 10h4"
    />
  </svg>
);
export default SvgFileIcon;
